export const cartKeys = {
  all: ["cart"] as const,
  cart: (locale: string) => ["cart", locale] as const,
  checkout: ["checkout"] as const,
  checkoutDelivery: ["checkoutDelivery"] as const,
};
